module.exports = __webpack_public_path__ + "static/media/055-bodybuilder.0918ffcd.svg";